import { AutocompleteProps } from '@mui/material';

import { Wrapper } from './styles';

export const Autocomplete = (props: AutocompleteProps<any, any, any, any>) => {
    return <Wrapper {...props} />;
};
